export function resolveMediaUrl(media: any) {
  if (!media) return null;
  if (typeof media === 'string') return media;

  return media.condensed || media.original || media.url || media.src || null;
}

export function getInitials(name: string) {
  return String(name || 'G')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
}
